/*eslint-disable*/
import { urlReg, email, ebcuZipCOde } from '@/modules/mdm/utils/regList.js'
// 特批标语
export const specialApprovalData = {
    acceptanceRatioMsg: '存在承兑比例大于0',
    creditPeriodDaysMsg: '存在总账期大于90天',
    paymentTermDaysMsg: '存在账期大于60天',
    tenderDepositMsg: '存在投标押金比例超过3%',
    operationDepositMsg: '存在运作押金比例超过3%'
}
// 表单配置信息
export const collapse = [
    {
        title: '基本信息',
        ref: 'basicForm',
        formName: 'basicInfo',
        col: 4,
        labelWidth: '120px',
        visible: true,
        formList: [
            {
                label: '单据标题',
                prop: 'billTitle',
                value: 'billTitle',
                type: 'input',
                sourceType: 'input',
                span: 12,
                rule: [
                    { required: true, message: '单据标题不能为空', trigger: 'change' }
                ]
            },
            {
                label: '申请人',
                prop: 'applicantName',
                value: 'applicantName',
                rule: [
                    { required: true, message: '申请人不能为空', trigger: 'change' }
                ],
                type: 'advance',
                advanceConfig: [
                    { 'prop': 'esusUserNameCn', 'value': '姓名' },
                    { 'prop': 'esusLoginName', 'value': '美信号' }
                ],
                tableConfig: [
                    { 'prop': 'esusLoginName', 'value': '美信号' },
                    { 'prop': 'esusUserNameCn', 'value': '姓名' },
                    { 'prop': 'esusPositionName', 'value': '职位' },
                    { 'prop': 'escoCompanyNameCn', 'value': '部门' }
                ],
                prefix: '/api-mdm',
                advanceUrl: `/selectUserCompany`,
                cbParams: ['esusUserNameCn#applicantName', 'esusLoginName#applicantCode'],
                span: 6,
            },
            {
                label: '所属部门',
                prop: 'departmentName',
                value: 'departmentName',
                type: 'advance',
                rule: [
                    { required: true, message: '所属部门不能为空', trigger: 'change' }
                ],
                advanceConfig: [
                    { 'prop': 'departmentName', 'value': '部门名称' },
                    { 'prop': 'departmentCode', 'value': '部门编码' }
                ],
                tableConfig: [
                    { 'prop': 'departmentCode', 'value': '部门编码' },
                    { 'prop': 'departmentName', 'value': '部门名称', 'displayName': 'departmentName' }
                ],
                method: 'post',
                prefix: '/api-lcrm',
                advanceUrl: `/customer/manager/archive/billDepartment/collect`,
                cbParams: ['departmentCode', 'departmentName'],
                span: 6,
            },
        ]
    },
    {
        title: '客户信息',
        ref: 'customerForm',
        formName: 'customerInfo',
        col: 4,
        labelWidth: '150px',
        visible: true,
        formList: [
            {
                label: '客户编码',
                prop: 'customerCode',
                value: 'customerCode',
                type: 'custom',
                rule: [
                    { required: true, message: '客户编码不能为空', trigger: 'change' }
                ]
            },
            {
                label: '客户名称',
                prop: 'customerName',
                value: 'customerName',
                type: 'advance',
                advanceConfig: [
                    { prop: 'customerName', value: '客户名称' },
                    { prop: 'customerCode', value: '客户编码' }
                ],
                tableConfig: [
                    { prop: 'customerName', value: '客户名称' },
                    { prop: 'customerCode', value: '客户编码' },
                    { prop: 'ebcuNameEn', value: '英文名称' },
                    { prop: 'customerShortName', value: '客户简称' },
                    { prop: 'ebcuEbplCountryName', value: '注册国家' },
                    { prop: 'ebcuEbplProvinceName', value: '省份' },
                    { prop: 'ebcuEbplCityName', value: '市' },
                    { prop: 'ebcuDistrictsName', value: '县区' },
                    { prop: 'ebcuTownsName', value: '乡镇/街道' },
                    { prop: 'ebcuAddress', value: '地址' },
                    { prop: 'ebcuCustomerType', value: '客户分类', type: 'select', optionsKey: 'EBCU_CUSTOMER_TYPE_OVERSEAS' },
                    { prop: 'isImpExpCustomer', value: '内外销', type: 'select', optionsKey: 'IS_IMP_EXP_CUSTOMER' },
                ],
                prefix: '/api-lcrm',
                advanceUrl: '/customer/info/page',
                // 'ebcuEbplCountryCode','ebcuEbplProvinceCode','ebcuEbplCityCode','ebcuDistricts'
                cbParams: ['customerCode', 'customerName', 'ebcuNameEn', 'customerShortName', 'ebcuEbplCountryName', 'ebcuEbplProvinceName',
                    'ebcuEbplCityName', 'ebcuDistrictsName', 'ebcuTownsName', 'ebcuAddress', 'ebcuCustomerType', 'isImpExpCustomer','ebcuEbplCityCode',
                    'ebcuEbplCountryCode','ebcuEbplProvinceCode','ebcuDistricts'],
                method: 'post',
                width: 250,
                visible: true,
                rule: [
                    { required: true, message: '客户名称不能为空', trigger: 'change' }
                ],
                opsUnlockType: 'advance'
            },
            {
                label: '英文名称',
                prop: 'ebcuNameEn',
                value: 'ebcuNameEn',
                type: 'custom',
                rule: [
                    { required: false }
                ],
            },
            {
                label: '客户简称',
                prop: 'customerShortName',
                value: 'customerShortName',
                type: 'custom',
                rule: [
                    { required: false }
                ],
            },
            {
                label: '注册国家',
                prop: 'ebcuEbplCountryName',
                value: 'ebcuEbplCountryName',
                type: 'custom',
                rule: [
                    { required: false }
                ],
            },
            {
                label: '省份',
                prop: 'ebcuEbplProvinceName',
                value: 'ebcuEbplProvinceName',
                type: 'custom',
                rule: [
                    { required: false }
                ],
            },
            {
                label: '市',
                prop: 'ebcuEbplCityName',
                value: 'ebcuEbplCityName',
                type: 'custom',
                rule: [
                    { required: false }
                ],
            },
            {
                label: '县区',
                prop: 'ebcuDistrictsName',
                value: 'ebcuDistrictsName',
                type: 'custom',
                rule: [
                    { required: false }
                ],
            },
            // {
            //     label: '乡镇/街道',
            //     prop: 'ebcuTownsName',
            //     value: 'ebcuTownsName',
            //     type: 'custom',
            //     rule: [
            //         { required: false, message: '乡镇/街道不能为空', trigger: 'change' }
            //     ],
            // },
            {
                label: '地址',
                prop: 'ebcuAddress',
                value: 'ebcuAddress',
                type: 'custom',
                span: 12,
                rule: [
                    { required: false }
                ],
            },
            {
                label: '客户分类',
                prop: 'ebcuCustomerType',
                value: 'ebcuCustomerType',
                type: 'custom',
                optionsKey: 'EBCU_CUSTOMER_TYPE_OVERSEAS',
                rule: [
                    { required: false }
                ],
            },
            {
                label: '内外销',
                prop: 'isImpExpCustomer',
                value: 'isImpExpCustomer',
                type: 'custom',
                optionsKey: 'IS_IMP_EXP_CUSTOMER',
                content: '当关联客户内外销=内销时，引入流程审批通过时更新该字段值为内外销；',
                rule: [
                    { required: false }
                ],
            },
        ]
    },
    {
        title: '客户引入信息',
        ref: 'registerForm',
        formName: 'registerInfo',
        col: 4,
        labelWidth: '180px',
        visible: true,
        formList: [
            {
                label: '销售产品',
                prop: 'salesProduct',
                value: 'salesProduct',
                type: 'input',
                sourceType: 'input',
                rule: [
                    { required: false, message: '销售产品不能为空', trigger: 'change' }
                ]
            },
            {
                label: '是否涉及危险品',
                prop: 'isHazardous',
                value: 'isHazardous',
                type: 'select',
                sourceType: 'select',
                optionsKey: 'SYS_IS_HAZARDOUS',
                rule: [
                    { required: true, message: '是否涉及危险品不能为空', trigger: 'change' }
                ],
            },
            {
                label: '海外业务类别',
                prop: 'overseasBusinessTypes',
                value: 'overseasBusinessTypes',
                type: 'select',
                sourceType: 'select',
                multiple: true,
                optionsKey: 'OVERSEAS_BUSINESS_TYPE',
                rule: [
                    { required: true, message: '海外业务类别不能为空', trigger: 'change' }
                ],
            },
            {
                label: '大航线',
                prop: 'routeCodes',
                value: 'routeCodes',
                type: 'select',
                sourceType: 'select',
                multiple: true,
                optionsKey: 'SYS_ROUTE_TYPE',
                rule: [
                    { required: false, message: '大航线不能为空', trigger: 'change' }
                ],

            },
            {
                label: '总账期',
                prop: 'creditPeriodDays',
                value: 'creditPeriodDays',
                type: 'input',
                sourceType: 'input',
                rule: [
                    { required: true, message: '总账期不能为空', trigger: ['change', 'blur'] },
                    {
                        validator: function (rule, value, callback) {
                            const reg = new RegExp('^[0-9]*$'); // 整数正则
                            if (!reg.test(value)) {
                                callback(new Error("请输入整数！！"));
                            } else {
                                callback();
                            }

                        }
                    }
                ]
            },
            {
                label: '账期（票后/天）',
                prop: 'paymentTermDays',
                value: 'paymentTermDays',
                type: 'input',
                sourceType: 'input',
                rule: [
                    { required: true, message: '账期（票后/天）不能为空', trigger: ['change', 'blur'] },
                    {
                        validator: function (rule, value, callback) {
                            const reg = new RegExp('^[0-9]*$'); // 整数正则
                            if (!reg.test(value)) {
                                callback(new Error("请输入整数！！"));
                            } else {
                                callback();
                            }

                        }
                    }
                ]
            },
            {
                label: '预计合作规模(万元)',
                prop: 'estimatedScale',
                value: 'estimatedScale',
                type: 'input',
                sourceType: 'input',
                content: '客户一年预计与安得合作的规模',
                rule: [
                    { required: true, message: '预计合作规模(万元)不能为空', trigger: ['change', 'blur'] },
                    {
                        validator: function (rule, value, callback) {
                            const reg = new RegExp(/^-?(0|([1-9]\d*))(\.\d+)?$/); // 数字正则
                            if (!reg.test(value)) {
                                callback(new Error("请输入数值！！"));
                            } else {
                                callback();
                            }

                        }
                    }
                ]
            },
            {
                label: '预计采购毛利率(%)',
                prop: 'estimatedGrossMargin',
                value: 'estimatedGrossMargin',
                type: 'input',
                sourceType: 'input',
                content: '合作规模对应的采购毛利率',
                rule: [
                    { required: true, message: '预计采购毛利率(%)不能为空', trigger: ['change', 'blur'] },
                    {
                        validator: function (rule, value, callback) {
                            const reg = new RegExp(/^-?(\d{1,4})(\.\d{1,2})?$/); // 数字正则，限制最大4位整数，2位小数
                            if (!reg.test(value)) {
                                callback(new Error("请输入最大4位整数，2位小数！！"));
                            } else {
                                callback();
                            }

                        }
                    }
                ]
            },
            {
                label: '投标押金(万元)',
                prop: 'tenderDeposit',
                value: 'tenderDeposit',
                type: 'input',
                sourceType: 'input',
                rule: [
                    { required: true, message: '投标押金(万元)不能为空', trigger: ['change', 'blur'] },
                    {
                        validator: function (rule, value, callback) {
                            const reg = new RegExp(/^-?(0|([1-9]\d*))(\.\d+)?$/); // 数字正则
                            if (!reg.test(value)) {
                                callback(new Error("请输入数值！！"));
                            } else {
                                callback();
                            }

                        }
                    }
                ]
            },
            {
                label: '运作押金(万元)',
                prop: 'operationDeposit',
                value: 'operationDeposit',
                type: 'input',
                sourceType: 'input',
                rule: [
                    { required: false, message: '运作押金(万元)不能为空', trigger: ['change', 'blur'] },
                    {
                        validator: function (rule, value, callback) {
                            const reg = new RegExp(/^-?(0|([1-9]\d*))(\.\d+)?$/); // 数字正则
                            if (value && !reg.test(value)) {
                                callback(new Error("请输入数值！！"));
                            } else {
                                callback();
                            }

                        }
                    }
                ]
            },
            {
                label: '结算方式',
                prop: 'settlementMethod',
                value: 'settlementMethod',
                type: 'select',
                sourceType: 'select',
                optionsKey: 'NEOCRM_SETTLEMENT',
                rule: [
                    { required: true, message: '结算方式不能为空', trigger: ['change'] },
                ],
            },
            {
                label: '承兑比例(%)',
                prop: 'acceptanceRatio',
                value: 'acceptanceRatio',
                type: 'input',
                sourceType: 'input',
                content: '承兑回款需要准入基础上增加3%资金成本特批',
                rule: [
                    { required: true, message: '承兑比例(%)不能为空', trigger: ['change', 'blur'] },
                    {
                        validator: function (rule, value, callback) {
                            const reg = new RegExp(/^-?(\d{1,3})(\.\d{1,2})?$/); // 数字正则，限制最大3位整数，2位小数
                            if (!reg.test(value)) {
                                callback(new Error("请输入最大3位整数，2位小数！！"));
                            } else {
                                callback();
                            }

                        }
                    }
                ],
            },
            {
                label: '是否特批',
                prop: 'isSpecialApproval',
                value: 'isSpecialApproval',
                type: 'custom',
                optionsKey: 'SYS_YES_NO',
                // visible: false,
                rule: [
                    { required: false, message: '是否特批不能为空', trigger: 'change' }
                ],
            },
            {
                label: '特批原因',
                prop: 'specialApprovalReason',
                value: 'specialApprovalReason',
                type: 'custom',
                span: 12,
                // visible: false,
                rule: [
                    { required: false, message: '特批原因不能为空', trigger: 'change' }
                ],
            },
            {
                label: '管理员特批',
                prop: 'adminSpecialApproval',
                value: 'adminSpecialApproval',
                type: 'custom',
                sourceType: 'select',
                optionsKey: 'SYS_YES_NO',
                // visible: false,
                // disabled: true,
                rule: [
                    { required: false, message: '管理员特批不能为空', trigger: 'change' }
                ],
            },
            {
                label: '附件',
                prop: 'fileName',
                value: 'fileName',
                type: 'custom',
                span: 12,
                opsUnlockType: 'custom',
                rule: [
                    { required: false, message: '请上传附件', trigger: 'change' }
                ],
            },

        ]
    },
    {
        title: '系统信息',
        ref: 'systemForm',
        formName: 'systemInfo',
        col: 4,
        labelWidth: '150px',
        visible: true,
        formList: [
            {
                label: '单据编码',
                prop: 'billCode',
                value: 'billCode',
                type: 'custom',
                rule: [
                    { required: false, message: '单据编码不能为空', trigger: 'change' }
                ]
            },
            {
                label: '单据类型',
                prop: 'billType',
                value: 'billType',
                type: 'custom',
                optionsKey: 'SYS_BILL_TYPE',
                rule: [
                    { required: false, message: '单据类型不能为空', trigger: 'change' }
                ]
            },
            {
                label: '审批状态',
                prop: 'approvalStatus',
                value: 'approvalStatus',
                optionsKey: 'SYS_SU_MIP_AUDIT_STATUS',
                type: 'custom',
                rule: [
                    { required: false, message: '审批状态不能为空', trigger: 'change' }
                ]
            },
            {
                label: '创建时间',
                prop: 'createTime',
                value: 'createTime',
                type: 'custom',
                rule: [
                    { required: false, message: '创建时间不能为空', trigger: 'change' }
                ]
            },
            {
                label: '创建人',
                prop: 'createUserName',
                value: 'createUserName',
                type: 'custom',
                rule: [
                    { required: false, message: '创建用户不能为空', trigger: 'change' }
                ]
            },
            {
                label: '修改时间',
                prop: 'updateTime',
                value: 'updateTime',
                type: 'custom',
                rule: [
                    { required: false, message: '更新时间不能为空', trigger: 'change' }
                ]
            },
            {
                label: '修改用户',
                prop: 'updateUserName',
                value: 'updateUserName',
                type: 'custom',
                rule: [
                    { required: false, message: '修改用户不能为空', trigger: 'change' }
                ]
            },
        ]
    },
];